import { FiX } from 'react-icons/fi'

export default function Close() {
    return (
        <div className="group w-12 h-12 relative flex items-center justify-center rounded-full text-white hover:text-red-600 hover:cursor-pointer">
            <div className="relative group-hover:rotate-12 duration-200">
                <FiX size={35} />
            </div>
        </div>
    )
}
